import { X, ChevronLeft } from 'lucide-react';

/** Props for the reusable panel header */
interface PanelHeaderProps {
  label: string;
  onClose: () => void;
  /** Optional back handler (e.g. return to the plugins hub); shows a back arrow. */
  onBack?: () => void;
  /** Optional slot for panel-specific actions (e.g. a Refresh button) */
  actions?: React.ReactNode;
  /** Optional ReactNode to render instead of the text label (e.g. a logo) */
  labelContent?: React.ReactNode;
}

/** Reusable header bar rendered at the top of every slide-out panel */
export function PanelHeader({ label, onClose, onBack, actions, labelContent }: PanelHeaderProps): React.JSX.Element {
  return (
    <div className="flex items-center justify-between border-b border-echo-border px-4 py-3">
      <div className="flex items-center gap-1.5">
        {onBack && (
          <button
            onClick={onBack}
            className="rounded p-1 text-muted-foreground transition-colors hover:bg-white/[0.06] hover:text-foreground"
            title="Back to plugins"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
        )}
        {labelContent ?? <h2 className="font-chakra text-sm font-semibold tracking-wide">{label}</h2>}
      </div>
      <div className="flex items-center gap-2">
        {actions}
        <button
          onClick={onClose}
          className="rounded p-1 text-muted-foreground transition-colors hover:bg-white/[0.06] hover:text-foreground"
          title="Close panel"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
